import { cva } from 'class-variance-authority'

export const skeletonStyles = cva(
  `
    animate-pulse 
    rounded-md 
    h-4
    w-full
    bg-neutral-200
  `
)
